import type { FindingSeverityType } from '@terra/shared-schemas-orchestrator';

export const isSeverityReasonMissing = ({
  severity,
  originalSeverity,
  severityReason,
}: {
  severity: FindingSeverityType;
  originalSeverity: FindingSeverityType | undefined;
  severityReason: string | undefined;
}): boolean =>
  originalSeverity !== undefined &&
  severity !== originalSeverity &&
  !severityReason?.trim();
